import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import IconWrapper from '@segment/matcha/components/IconWrapper'
import { AnnouncementIcon, PlugIcon, UserIcon } from '@segment/matcha/components/Icons/Brandbook'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import RealTimeAudiencesImage from './DeliverUnifiedCustomerExperiencesImage'

const copy = {
  heading: `Deliver unified, personalized customer experiences`,
  description: `Build and activate data-driven, personalized campaigns across every customer channel from a centralized platform without relying on technical teams.`,
}

const link = {
  text: `Explore Twilio Engage`,
  url: `/product/twilio-engage/`,
}

const features = [
  {
    heading: `Engage anywhere in real time`,
    description: `Activate insights in real time, eliminating the need for manual data reconciliation and collaboration with other teams and systems.`,
    icon: <AnnouncementIcon />,
  },
  {
    heading: `Orchestrate journeys wherever your data is`,
    description: `Enhance customer engagement with personalized experiences across their preferred channels—email, SMS, WhatsApp, Push Notifications, and more—leveraging our 450+ ready-to-use integrations and customizable options.`,
    icon: <PlugIcon />,
  },
  {
    heading: `Build a complete view of your customer`,
    description: `Create profiles and audiences with real-time customer interactions collected across digital touchpoints, without SQL expertise.`,
    icon: <UserIcon />,
  },
]
const DeliverUnifiedCustomerExperiences = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionWrapper variant="2Col" copyVariant="narrow" reverse={true}>
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>

        <ColumnTrackWrapper>
          <ColumnTrack gap="small">
            {features.map((feature, index) => (
              <FeatureBoxBase key={index} alignment="left" headerPosition="left">
                <FeatureBox.Header>
                  <IconWrapper elevation={1} variant="circle">
                    {feature.icon}
                  </IconWrapper>
                </FeatureBox.Header>
                <FeatureBox.Body>
                  <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                  <FeatureBox.Text>{feature.description}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </ColumnTrackWrapper>
      </Section.Copy>

      <Section.Contents>
        <RealTimeAudiencesImage />
      </Section.Contents>
    </SectionWrapper>
  )
}

const SectionWrapper = styled(SectionBase)`
  overflow-x: visible;
  ${Section.Wrapper} {
    ${Section.Copy} {
      max-width: 440px;
    }
  }
`

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

export default DeliverUnifiedCustomerExperiences
